(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
function fpScroll(id, dir) {
  var track = document.getElementById('fp-track-' + id);
  if (!track) return;
  var item = track.querySelector('.fp-item');
  var step = item ? item.offsetWidth + 16 : track.offsetWidth * 0.8;
  track.scrollBy({ left: dir * step, behavior: 'smooth' });
}

(function () {
  document.querySelectorAll('.fp-section').forEach(function (section) {
    section.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || !form.action.includes('/cart/add')) return;
      e.preventDefault();
      s3AjaxAddToCart(form);
    });
  });
}());

window.s3AjaxAddToCart = window.s3AjaxAddToCart || function (form) {
  var btn = form.querySelector('[type="submit"]');
  var originalText = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = '...'; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
    body: new FormData(form)
  })
    .then(function (r) { return r.json(); })
    .then(function (item) {
      if (item.status) { console.warn('Cart error:', item.description); return; }
      document.dispatchEvent(new CustomEvent('cart:open',       { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: item }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('CartDrawer:open', { bubbles: true }));
      return fetch('/cart.js', { headers: { Accept: 'application/json' } });
    })
    .then(function (r) { return r && r.json(); })
    .then(function (cart) {
      if (!cart) return;
      document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count, .header__cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
    })
    .catch(function () { window.location.href = form.action; })
    .finally(function () {
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
    });
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var toggle   = document.getElementById('col-filter-toggle');
  var closeBtn = document.getElementById('col-filter-close');
  var panel    = document.getElementById('filter-panel');

  function openFilter() {
    if (!panel) return;
    panel.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
  }
  function closeFilter() {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.focus();
  }

  if (toggle)   toggle.addEventListener('click', openFilter);
  if (closeBtn) closeBtn.addEventListener('click', closeFilter);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilter(); });

  /* ── intercept add-to-cart inside the products grid ── */
  var grid = document.querySelector('.products-grid');
  if (grid) {
    grid.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || !form.action.includes('/cart/add')) return;
      e.preventDefault();
      s3AjaxAddToCart(form);
    });
  }
}());

function S3ApplyFilters() {
  var params = new URLSearchParams(window.location.search);
  document.querySelectorAll('#filter-panel input[type="checkbox"]').forEach(function (cb) {
    params.delete(cb.name);
  });
  document.querySelectorAll('#filter-panel input[type="checkbox"]:checked').forEach(function (cb) {
    params.append(cb.name, cb.value);
  });
  var min = document.getElementById('filter-price-min');
  var max = document.getElementById('filter-price-max');
  if (min && min.name) params.set(min.name, min.value || '');
  if (max && max.name) params.set(max.name, max.value || '');
  window.location.href = window.location.pathname + '?' + params.toString();
}

window.s3AjaxAddToCart = window.s3AjaxAddToCart || function (form) {
  var btn = form.querySelector('[type="submit"]');
  var originalText = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = '...'; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
    body: new FormData(form)
  })
    .then(function (r) { return r.json(); })
    .then(function (item) {
      if (item.status) { console.warn('Cart error:', item.description); return; }
      document.dispatchEvent(new CustomEvent('cart:open',       { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: item }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('CartDrawer:open', { bubbles: true }));
      return fetch('/cart.js', { headers: { Accept: 'application/json' } });
    })
    .then(function (r) { return r && r.json(); })
    .then(function (cart) {
      if (!cart) return;
      document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count, .header__cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
    })
    .catch(function () { window.location.href = form.action; })
    .finally(function () {
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
    });
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ── Image gallery ── */
  var mainImg = document.getElementById('pdp-main-img');
  document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.style.opacity = '0';
      mainImg.src = this.dataset.imgSrc;
      if (this.dataset.imgSrcset) mainImg.srcset = this.dataset.imgSrcset;
      mainImg.addEventListener('load', function () { mainImg.style.opacity = '1'; }, { once: true });
      document.querySelectorAll('.pdp-thumb').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      this.classList.add('is-active');
      this.setAttribute('aria-pressed', 'true');
    });
  });

  /* ── Quantity stepper ── */
  var qtyCtrl = document.querySelector('.pdp-qty-ctrl');
  if (qtyCtrl) {
    var qtyInput = qtyCtrl.querySelector('.pdp-qty-val');
    qtyCtrl.querySelector('[data-qty-dec]').addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyCtrl.querySelector('[data-qty-inc]').addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });
  }

  /* ── Variant selection ── */
  var formWrap = document.querySelector('.pdp-form-wrap');
  if (formWrap) {
    var variantData = JSON.parse(formWrap.querySelector('[data-variants-json]').textContent);
    var variantInput = formWrap.querySelector('[data-variant-id]');
    var atcBtn  = formWrap.querySelector('[data-atc-btn]');
    var atcText = atcBtn ? atcBtn.querySelector('[data-atc-text]') : null;
    var priceEl  = document.querySelector('[data-price]');
    var wasEl    = document.querySelector('[data-price-was]');
    var saveEl   = document.querySelector('[data-save-badge]');
    var stickyPr = document.querySelector('[data-sticky-price]');

    function formatMoney(cents) {
      if (window.S3 && window.S3.moneyFormat) {
        return window.S3.moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/g, (cents / 100).toFixed(2))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.floor(cents / 100)));
      }
      return (cents / 100).toFixed(2);
    }

    formWrap.querySelectorAll('.pdp-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = this.closest('.pdp-opt-group');
        group.querySelectorAll('.pdp-pill').forEach(function (p) {
          p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-pressed', 'true');
        if (this.dataset.labelEl) {
          var el = document.getElementById(this.dataset.labelEl);
          if (el) el.textContent = this.dataset.optionValue;
        }

        var selected = {};
        formWrap.querySelectorAll('.pdp-opt-group').forEach(function (g, i) {
          var active = g.querySelector('.pdp-pill.is-active');
          if (active) selected['option' + (i + 1)] = active.dataset.optionValue;
        });

        var match = variantData.find(function (v) {
          return Object.keys(selected).every(function (k) { return v[k] === selected[k]; });
        });
        if (!match) return;

        if (variantInput) variantInput.value = match.id;
        var fmt = formatMoney(match.price);
        if (priceEl)  priceEl.textContent  = fmt;
        if (stickyPr) stickyPr.textContent = fmt;

        if (match.compare_at_price && match.compare_at_price > match.price) {
          if (wasEl)  { wasEl.textContent  = formatMoney(match.compare_at_price); wasEl.hidden  = false; }
          if (saveEl) { saveEl.textContent = 'SAVE ' + Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100) + '%'; saveEl.hidden = false; }
        } else {
          if (wasEl)  wasEl.hidden  = true;
          if (saveEl) saveEl.hidden = true;
        }

        if (atcBtn) {
          atcBtn.disabled = !match.available;
          if (atcText) atcText.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      });
    });
  }

  /* ── Live viewers ── */
  var viewersEl = document.getElementById('pdp-viewers-count');
  if (viewersEl) {
    var vc = Math.floor(Math.random() * 8) + 9;
    viewersEl.textContent = vc;
    setInterval(function () {
      vc = Math.max(8, vc + Math.round((Math.random() - 0.4) * 2));
      viewersEl.textContent = vc;
    }, 4500);
  }

  /* ── Countdown ── */
  var hero = document.querySelector('[data-pdp-hero]');
  var cdH  = document.querySelectorAll('[data-cdh]');
  if (cdH.length && hero) {
    var key = 's3_cd_' + (hero.dataset.productId || 'x');
    var tgt = parseInt(localStorage.getItem(key), 10);
    if (!tgt || tgt < Date.now()) {
      tgt = Date.now() + 6 * 3600 * 1000;
      localStorage.setItem(key, tgt);
    }
    var cdM = document.querySelectorAll('[data-cdm]');
    var cdS = document.querySelectorAll('[data-cds]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tickCd() {
      var diff = Math.max(0, tgt - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      cdH.forEach(function (el) { el.textContent = pad(h); });
      cdM.forEach(function (el) { el.textContent = pad(m); });
      cdS.forEach(function (el) { el.textContent = pad(s); });
    }
    tickCd();
    setInterval(tickCd, 1000);
  }

  /* ── Tabs ── */
  document.querySelectorAll('[data-tabs-wrapper]').forEach(function (wrapper) {
    var btns = wrapper.querySelectorAll('.pdp-tab-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');
        wrapper.querySelectorAll('.pdp-tab-panel').forEach(function (p) { p.classList.remove('is-active'); });
        var panel = document.getElementById(this.dataset.tab);
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  /* ── Scroll-to-reviews link ── */
  document.querySelectorAll('[data-open-tab]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var btn = document.querySelector('[data-tab="' + this.dataset.openTab + '"]');
      if (btn) btn.click();
      var tabs = document.querySelector('[data-tabs-wrapper]');
      if (tabs) tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ── Sticky ATC submit ── */
  document.querySelectorAll('[data-submit-form]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById(this.dataset.submitForm);
      if (form) { var add = form.querySelector('[name=add]'); if (add) add.click(); }
    });
  });

  /* ── Sticky bar show/hide ── */
  var stickyBar = document.getElementById('pdp-sticky');
  var mainAtc   = document.querySelector('.pdp-main-atc');
  if (stickyBar && mainAtc) {
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      stickyBar.classList.toggle('is-visible', !visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0.1 }).observe(mainAtc);
  }
  
}());

  } catch(e) { console.error(e); }
})();
})();
